import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";

export default function ServerTime() {
  const serverTime = useSelector(
    (state: RootState) => state.admin?.serverTime,
    isEqual,
  );

  const timezoneDisplay = serverTime?.timezone ?? "Unknown";

  return (
    <div className={styles.container}>
      <div className={styles.header}>Server Time ({timezoneDisplay})</div>
      <div className={styles.serverTime}>{serverTime?.time ?? "N/A"}</div>
    </div>
  );
}
